<template>
  <div class="app__content">
    <div class="app__content__cta">
      <div class="app__content__block app__content__block--login">
        <div>
          <h2>
            Ik heb al een account!
          </h2>
          <a class="button" href="https://v-packs.dropon.io">Log in</a>
        </div>
      </div>
      <div class="app__content__block app__content__block--register">

        <h2>Ik heb nog geen account</h2>
        <Register></Register>
      </div>
    </div>
    <div class="app__content__info">
      <a target="_blank" href="https://v-tax.be/services?service=packs" class="button button--secondary">Meer
        informatie?</a>
    </div>
  </div>
</template>

<script>
import Register from "@/components/Register";

export default {
  name: "Home",
  components: {
    Register
  },
  data() {
    return {
      formTimeout: null,
      isFormActive: false,
      isRegistering: false
    }
  }
}
</script>

<style scoped>

</style>